import { useQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { SEARCH_JOB_OFFER_TEMPLATE_FILTERS } from '@gql/jobOfferTemplates';
import { IJobOfferTemplateFilter } from '../JobOfferTemplateFilter';

export interface IJobOfferTemplateAvailableFilters {
    proIds: { value: string; label: string; count: number }[];
    brandIds: { value: string; label: string; count: number }[];
}

const defaultAvailableFilters: IJobOfferTemplateAvailableFilters = {
    proIds: [],
    brandIds: [],
};

export const useGetJobOfferTemplateAvailableFilters = (
    query: string,
    filter: IJobOfferTemplateFilter,
) => {
    const { user } = useAuth();

    const transformedFilter: Record<string, any> = {};

    if (filter.proId?.length) {
        transformedFilter.proId = filter.proId;
    }
    if (filter.brandId?.length) {
        transformedFilter.brandId = filter.brandId;
    }
    if (filter.createdAt?.start || filter.createdAt?.end) {
        transformedFilter.createdAt = {
            start: filter.createdAt.start ?? null,
            end: filter.createdAt.end ?? null,
        };
    }

    const { data, loading } = useQuery(SEARCH_JOB_OFFER_TEMPLATE_FILTERS, {
        variables: { query, filter: transformedFilter },
        fetchPolicy: 'cache-and-network',
        skip: !user,
    });

    return {
        availableFilters: (data?.searchJobOfferTemplateFilters as IJobOfferTemplateAvailableFilters) ?? defaultAvailableFilters,
        loading,
    };
};
